module.exports = __webpack_public_path__ + "images/emoji/pill.c92d19c4c9b81ee75be1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pill.png
// module id = r6mM
// module chunks = 24